import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { EndUser } from '@driftt/api-types'

import { driftEmptyStateBuilder } from 'components/States'
import { AccountDetailsPageParams } from 'hooks/useAccountCompanyTitle'
import { SessionMetrics } from 'hooks/useSessionMetrics'
import CCRMFeed from 'sections/CCRM/Feed'
import { Timeline } from 'typings/timeline'

import AboutContactSection from '../AboutContactSection'
import MostRecentChatSection from '../MostRecentChatSection'

import styles from './styles.module.css'

interface FeedTabProps {
  user: EndUser | undefined
  sessionMetrics: SessionMetrics
  mostRecentChat: Timeline | null
  personalIntel: any
  unifiedAttributes: any
}

const FeedTab = (props: FeedTabProps) => {
  const { user, sessionMetrics, mostRecentChat, personalIntel, unifiedAttributes } = props
  const { id: endUserId } = useParams<AccountDetailsPageParams>()

  const EmptyComponent = useMemo(
    () =>
      driftEmptyStateBuilder(
        'No contact activity yet',
        'Once your contact visits your site, it will show up here.'
      ),
    []
  )

  return (
    <>
      <div className={styles.leftSide}>
        <div className={styles.feedContainer}>
          <CCRMFeed
            contactId={endUserId}
            scrollTargetId="contactDetailsPage"
            includeAllTimeActivities
            sessionMetrics={sessionMetrics}
            includeSortControl={false}
            withFilters={false}
            emptyComponent={EmptyComponent}
          />
        </div>
      </div>
      <div className={styles.rightSide}>
        <AboutContactSection
          user={user}
          personalIntel={personalIntel}
          unifiedAttributes={unifiedAttributes}
        />
        {mostRecentChat && <MostRecentChatSection mostRecentChat={mostRecentChat} />}
      </div>
    </>
  )
}

export default FeedTab
